import {styled} from '@material-ui/core'

export const Container = styled('div')(({theme}) => ({
  alignItems: 'flex-start',
  display: 'flex',
  flexDirection: 'column',
  flexShrink: 0,
  gap: '4px',
  height: '176px',
  padding: '24px',
  width: '363px',
  borderRadius: '8px',
  background: '#F1F5F9',

  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}))

export const Text = styled('span')({
  color: 'rgba(0, 0, 0, 0.6)',
  fontSize: '13px',
  fontWeight: 400,
  lineHeight: '160%',
  letterSpacing: '0.15px',
})

export const Title = styled('span')({
  color: 'rgba(0, 0, 0, 0.6)',
  fontSize: '16px',
  fontWeight: 700,
  lineHeight: '160%',
  letterSpacing: '0.15px',
})
